import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ISendToEtpExecutorProps } from './ISendToEtpExecutorProps';
import { SendToEtpExecutorModal } from './SendToEtpExecutorModal';

export const SendToEtpExecutor = createDocModalExecutor<ISendToEtpExecutorProps>({
    modal: SendToEtpExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        message: action.options?.title ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
